import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';

export const AppBarNav = ({ children }: { children: React.ReactNode }) => (
  <StackLayout as="nav" orientation="horizontal" verticalAlignment="stretch">
    {children}
  </StackLayout>
);
